import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabH as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabH = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" direction="column" style={{ height: "100%" }}>
        <Typography variant="h5">Participants in Dual Enrollment Programs</Typography>

        <Grid container spacing="lg">
          <Grid item xs={12}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}></Grid>
              <Grid item xs={2} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  Target Schools
                </Typography>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={2} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  Non-Target Schools
                </Typography>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={2} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  Total
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Row 1 */}
          <Grid item xs={12}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="caption">
                  Enrolled in Dual Enrollment Program
                </Typography>
              </Grid>

              {props.data?.yesTargetSchool != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.yesTargetSchool}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.yesNonTargetSchool != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.yesNonTargetSchool}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.yesTargetSchool != null && props.data?.yesNonTargetSchool != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.yesTargetSchool + props.data.yesNonTargetSchool}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Row 2 */}
          <Grid item xs={12} style={{ background: "#f5f5f5" }}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="caption">
                  Not Enrolled in Dual Enrollment Program
                </Typography>
              </Grid>

              {props.data?.noTargetSchool != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noTargetSchool}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.noNonTargetSchool != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNonTargetSchool}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.noTargetSchool != null && props.data?.noNonTargetSchool != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noTargetSchool + props.data.noNonTargetSchool}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Row 3 */}
          <Grid item xs={12}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="caption">
                  Unknown
                </Typography>
              </Grid>

              {props.data?.unknownTargetSchool != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.unknownTargetSchool}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.unknownNonTargetSchool != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.unknownNonTargetSchool}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.unknownTargetSchool != null && props.data?.unknownNonTargetSchool != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.unknownTargetSchool + props.data.unknownNonTargetSchool}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Grand Total */}
          <Grid item xs={12} style={{ background: "#f5f5f5" }}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="h6">Total</Typography>
              </Grid>

              {props.data?.targetSchoolTotalParticipants != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.targetSchoolTotalParticipants}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.nonTargetSchoolTotalParticipants != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.nonTargetSchoolTotalParticipants}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.targetSchoolTotalParticipants != null && props.data?.nonTargetSchoolTotalParticipants != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.targetSchoolTotalParticipants + props.data.nonTargetSchoolTotalParticipants}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={12}>
            <PieChart id="pie-tab-h" dataSource={props.data?.chartValues} palette="Bright" title="Participants" width="100%">
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
